import repository from './repository';
import axios from 'axios';

const API = process.env.VUE_APP_API_URL;
let DashboardRepository = repository('/dashboard');

DashboardRepository.index = (id) => {
    return axios.post(API + '/dashboard', {project_id: id});
};

DashboardRepository.distribution = (id) => {
    return axios.post(API + '/dashboard/task_distribution', {project_id: id});
};

DashboardRepository.history = (id) => {
    return axios.post(API + '/dashboard/task_history', {project_id: id});
};

DashboardRepository.failedTaskInfo = (id) => {
    return axios.post(API + '/dashboard/failed_tasks_info', {project_id: id});
};

DashboardRepository.taskDetails = (id) => {
    return axios.post(API + '/dashboard/task_details', {task_id: id});
};

DashboardRepository.default = () => {
    return {
        user_info: {firstname: "", lastname: "", email: ""},
        tasks_info: {
            total: 0,
            completed_tasks: 0,
            queued_tasks: 0,
            failed_tasks: 0,
            processing_tasks: 0,
            partially_failed: 0
        }
    };
};

export default DashboardRepository;
